<script setup>
import { onMounted } from 'vue'
import { iframeResizer } from 'iframe-resizer'

const props = defineProps({
  src: {
    type: String,
    required: true
  },
  iframeId: {
    type: String,
    default: () => `resizable-iframe-${Math.random().toString(36).substring(2, 9)}`
  }
})

onMounted(() => {
  iframeResizer(
    {
      checkOrigin: false,
      
    },
    `#${props.iframeId}` 
  )
})
</script>

<template>
  <iframe
    :id="props.iframeId"
    :src="props.src"
    style="width: 1px; min-width: 100%; border: none;"
  />
</template>
